import { lazy } from 'react';
import { createBrowserRouter } from 'react-router';
import { HomeFilled } from '@ant-design/icons';
import { MainLayout } from '~/application/layout/MainLayout';

import logs from '~/domain/logs/route';
import product from '~/domain/product/route';
import purchaseOrder from '~/domain/purchase-order/route';
import receivingList from '~/domain/receiving-list/route';
import salesOrder from '~/domain/sales-order/route';
import shippingProvider from '~/domain/shipping-provider/route';
import supplier from '~/domain/supplier/route';
import user from '~/domain/user/route';
import warehouse from '~/domain/wms/pages/route';
import webshopApiKey from '~/domain/webshop-api-key/route';
import webshop from '~/domain/webshop/route';

import { AuthenticatedOutlet } from '~/application/outlet/AuthenticatedOutlet';
import { AuthLayout } from './layout/AuthLayout';
import { AuthorizedOutlet } from '~/application/outlet/AuthorizedOutlet';
import { NonAuthenticatedOutlet } from '~/application/outlet/NonAuthenticatedOutlet';

const HomePage = lazy(() => import('./pages/index'));
const LoginPage = lazy(() => import('./pages/login'));

export const router = createBrowserRouter([{
    Component: NonAuthenticatedOutlet,
    children: [{
        Component: AuthLayout,
        children: [{
            path: '/login',
            Component: LoginPage,
        }]
    }],
}, {
    Component: AuthenticatedOutlet,
    children: [{
        Component: AuthorizedOutlet,
        children: [{
            path: '/',
            Component: MainLayout,
            Icon: HomeFilled,
            title: 'Home',
            children: [
                { index: true, Component: HomePage },
                logs,
                product,
                purchaseOrder,
                receivingList,
                salesOrder,
                shippingProvider,
                supplier,
                user,
                warehouse,
                webshop,
                webshopApiKey,
            ],
        }],
    }],
}]);
